import React, { useEffect, useState } from 'react';
import { searchRefunds } from '../../../api/sportaloka-client';
import { format } from 'date-fns';
import { getWithdrawStatusColor, getWithdrawStatusLabel } from '../../../helpers/status';
import { Link } from 'react-router-dom';

function RecentRefund() {
  const [paginationOptions, setPaginationOptions] = useState({
    page: 1,
    limit: 5,
    sort_field: 'created_at',
    sort_value: 'desc',
    booking_code: '',
    date: '',
    status: ['NEW', 'PROCESS', 'DECLINED', 'DONE']
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    getData();
  }, [paginationOptions]);

  const getData = async () => {
    try {
      setLoading(true);
      setError(false);
      setData([]);
      const query = new URLSearchParams({
        page: paginationOptions.page,
        limit: paginationOptions.limit,
        sort_field: paginationOptions.sort_field,
        sort_value: paginationOptions.sort_value,
        status: ['NEW', 'PROCESS'],
        booking_code: paginationOptions.booking_code,
        ...(paginationOptions.date && { date: paginationOptions.date })
      }).toString();
      const response = await searchRefunds(query);
      const responseData = response.data.data.data;
      setData(responseData);
      setTotalRows(response.data.data.total_rows);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
    }
  };

  return (
    <div className="overflow-scroll scroll-bar-1 mb-20 h-100">
      <table className="table-2 col-12">
        <thead>
          <tr>
            <th className="nowrap text-14">Tanggal</th>
            <th className="nowrap text-14">Kode Booking</th>
            <th className="nowrap text-14">Jumlah</th>
            <th className="nowrap text-14">Status</th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <th className="text-center" colSpan="6">
                Loading data...
              </th>
            </tr>
          )}
          {!loading && data.length === 0 && !error && (
            <tr>
              <th className="text-center text-light-1" colSpan="6">
                No data
              </th>
            </tr>
          )}
          {error && (
            <tr>
              <th className="text-center" colSpan="6">
                Tidak ada koneksi internet,{' '}
                <span className="text-danger cursor-pointer" onClick={getData}>
                  Coba kembali
                </span>
              </th>
            </tr>
          )}
          {data.map((row) => (
            <tr key={row.id}>
              <td className="nowrap text-left">{format(new Date(row.created_at), 'dd/MM/yyyy')}</td>
              <td className="nowrap text-left">
                <Link
                  to={`/booking/detail/${row.booking.id}`}
                  target="_blank"
                  className="fw-600 cursor-pointer text-primary">
                  <p>{row.booking.booking_code}</p>
                </Link>
              </td>
              <td className="nowrap text-left">IDR {row.total_price.toLocaleString('id-ID')}</td>
              <td className="nowrap text-left">
                <div
                  style={{ width: 'auto', display: 'inline-block' }}
                  className={`py-1 px-3 text-center text-12 rounded-1 fw-600 ${getWithdrawStatusColor(row.status)}`}>
                  {getWithdrawStatusLabel(row.status)}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default RecentRefund;
